import { render, staticRenderFns } from "./ImportToInvoiceModal.vue?vue&type=template&id=022c3bf0&scoped=true&"
import script from "./ImportToInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./ImportToInvoiceModal.vue?vue&type=script&lang=js&"
import style1 from "./ImportToInvoiceModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c3bf0",
  null
  
)

export default component.exports